import { Grid, RadioGroup, FormControlLabel, Radio, FormHelperText } from '@vapor/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CustomerType, ReferenceCustomersLookupDocument } from 'src/api/api.generated'
import BaseCustomerLookupComponent, { BaseCustomerLookup } from 'src/app/components/customer-lookup/base/base-customer-lookup'
import { GuestFooterOption } from 'src/app/components/customer-lookup/guest-lookup'
import { SimpleCustomerLookupOption } from 'src/app/components/customer-lookup/option/simple-customer-lookup-option'
import useCurrentLocale from 'src/app/hooks/current-locale/use-current-locale'

export type CustomerTypeLookupProps = {
  value: BaseCustomerLookup | { id: string } | null
  onChange: (value: BaseCustomerLookup | null) => void
  onCreateClick: (name: { lastName: string; firstName: string; type: CustomerType }) => void
  disabled?: boolean
  error?: boolean
}
export default function CustomerTypeLookup({ value, onChange, onCreateClick, disabled, error }: CustomerTypeLookupProps) {
  const { t } = useTranslation()
  const [type, setType] = useState<CustomerType | null>(null)
  const { hicLanguage } = useCurrentLocale()

  useEffect(() => {
    if (value !== null && 'type' in value && value.type !== type) {
      setType(value.type ?? null)
    }
  }, [value, type])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <RadioGroup
          row
          onChange={(event) => {
            switch (event.target.value) {
              case CustomerType.PERSON:
                setType(CustomerType.PERSON)
                break
              case CustomerType.COMPANY:
                setType(CustomerType.COMPANY)
                break
            }
            onChange(null)
          }}
          value={value !== null && 'type' in value ? value.type : type}
        >
          <FormControlLabel value={CustomerType.PERSON} control={<Radio size="small" />} label={t('commons.customer_type.person')} disabled={disabled} />
          <FormControlLabel value={CustomerType.COMPANY} control={<Radio size="small" />} label={t('commons.customer_type.company')} disabled={disabled} />
          <FormHelperText error={error}>{error}</FormHelperText>
        </RadioGroup>
      </Grid>
      <Grid item xs={12}>
        <BaseCustomerLookupComponent<BaseCustomerLookup> //
          customerType={type || undefined}
          value={value && value.id !== '' ? value : null}
          onChange={(v) => {
            onChange(v)
          }}
          queryDocument={ReferenceCustomersLookupDocument}
          renderOption={(option) => <SimpleCustomerLookupOption option={{ ...option, language: hicLanguage }} />}
          onCustomerUpserted={(customer) => customer}
          disabled={disabled || !type}
          error={error}
          footerOption={(inputValue, onClose) => (
            <GuestFooterOption //
              text={inputValue}
              onCreatePersonClick={(value) => {
                if (type) onCreateClick({ ...value, type: type })
              }}
              onClose={onClose}
              minSearchParameterLenght={3}
              caption={type === CustomerType.PERSON ? t('pms.components.customer_lookup.name_input_tip') : t('pms.components.customer_lookup.company_name_input_tip')}
            />
          )}
          noOptionsText={<i>{type === CustomerType.PERSON ? t('pms.components.customer_lookup.name_input_tip') : t('pms.components.customer_lookup.company_name_input_tip')}</i>}
        />
      </Grid>
    </Grid>
  )
}
